import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
  Tooltip,
} from "@mui/material";
import { Link } from "react-router-dom";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";

// Sample Data
const membersData = [
  {
    name: "Salona Mishra",
    role: "Project Manager",
    project: "Project Quantum",
    desk: "Worked Desk 1",
    action: "Add",
    actionColor: "#27AE60",
    timeChange: "20:40",
  },
  {
    name: "Ilqa Rasul",
    role: "Developer",
    project: "SkyGrid",
    desk: "Worked Desk 2",
    action: "Add",
    actionColor: "#27AE60",
    timeChange: "28:10",
  },
  {
    name: "Divya Goel",
    role: "Project Manager",
    project: "CodeFusion",
    desk: "Worked Desk 3",
    action: "Delete",
    actionColor: "#F4413D",
    timeChange: "00:15",
  },
  {
    name: "Ravi Kumar",
    role: "Product Designer",
    project: "Digital Marketing",
    desk: "Worked Desk 4",
    action: "Add",
    actionColor: "#27AE60",
    timeChange: "30:15",
  },
];

// Skeleton loader
const TableRowsLoader = ({ rowsNum }) => {
  return [...Array(rowsNum)].map((_, index) => (
    <TableRow key={index}>
      <TableCell>
        <Skeleton variant="text" width={20} height={20} />
      </TableCell>
      <TableCell>
        <Box display="flex" alignItems="center" gap={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={80} height={15} />
          </Box>
        </Box>
      </TableCell>
      <TableCell>
        <Box display="flex" alignItems="center" gap={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={80} height={15} />
          </Box>
        </Box>
      </TableCell>
      <TableCell>
        <Skeleton variant="rectangular" width={80} height={36} />
      </TableCell>
      <TableCell align="right">
        <Skeleton variant="text" width={50} height={20} />
      </TableCell>
    </TableRow>
  ));
};

const ManualTimesheet = () => {
  const [members, setMembers] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      setMembers(membersData);
    }, 2000);
  }, []);

  return (
    <Paper className="card-body p-20 bg-base border rounded-3 h-100" sx={{ boxShadow: "none" }}>
      <Box display="flex" justifyContent="space-between" sx={{ flexWrap: { sm: 'wrap' } }} className="pb-16 mb-0 border-bottom">
        <h6 className=" fw-semibold mb-0" style={{fontSize: '17px'}}>
          Manual Timesheet
          <Tooltip title="Manual Timesheet" arrow placement="top">
            <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
              <InfoOutlineIcon fontSize="small" />
            </button>
          </Tooltip>
        </h6>
        <a href="/ManualTimeEdits"   style={{ cursor: "pointer", fontSize: '14px', color: '#004DFF', }}>
          View report
        </a>
       
      </Box>

      <TableContainer>
        <Table className="tablegridall">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Member</TableCell>
              <TableCell>Project</TableCell>
              <TableCell>Action</TableCell>
              <TableCell align="right">Time Changed</TableCell>
            </TableRow>
          </TableHead>

          <TableBody
            sx={{
              "& .MuiTableCell-root": {
                borderBottom: "none",
              },
            }}
          >
            {!members ? (
              <TableRowsLoader rowsNum={4} />
            ) : (
              members.map((member, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Avatar sx={{ bgcolor: "#1976d2", fontSize: "14px" }}>
                        {member.name
                          .split(" ")
                          .map((n) => n[0])
                          .join("")
                          .toUpperCase()}
                      </Avatar>
                      <Box>
                        <Typography variant="body1" sx={{ fontSize: "14px", fontWeight: 600, color: "#1A1F36" }}>
                          {member.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {member.role}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>

                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Avatar sx={{ bgcolor: "#9c27b0", fontSize: "14px" }}>
                        {member.project
                          .split(" ")
                          .map((word) => word[0])
                          .join("")
                          .toUpperCase()}
                      </Avatar>
                      <Box>
                        <Typography variant="body1" sx={{ fontSize: "14px", fontWeight: 600, color: "#1A1F36" }}>
                          {member.project}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {member.desk}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>

                  <TableCell>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: member.actionColor,
                        color: "#fff",
                        textTransform: "capitalize",
                        "&:hover": {
                          backgroundColor: member.actionColor,
                          opacity: 0.9,
                        },
                      }}
                    >
                      {member.action}
                    </Button>
                  </TableCell>

                  <TableCell align="right">
                    <Typography variant="body2">{member.timeChange}</Typography>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ManualTimesheet;
